import { STATS_MARQUEE } from "@/data/products";

export const Marquee = ({ items: customItems }) => {
  const source = customItems || STATS_MARQUEE;
  const items = [...source, ...source];
  return (
    <div data-testid="stats-marquee" className="border-y border-[var(--border-default)] py-5 bg-[var(--bg-secondary)] overflow-hidden">
      <div className="inline-flex animate-marquee whitespace-nowrap">
        {items.map((s, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-[var(--text-secondary)]">{s}</span>
            <span className="w-1.5 h-1.5 bg-[var(--brand-primary)] rotate-45" />
          </span>
        ))}
      </div>
    </div>
  );
};
